module.exports = __webpack_public_path__ + "img/edge_divers_partage.9c237882.svg";